(()=>{var H=(t,e)=>()=>(t&&(e=t(t=0)),e);var nt=(t,e)=>()=>(e||t((e={exports:{}}).exports,e),e.exports);function D(t,e){for(var o in e)t[o]=e[o];return t}function ie(t){t&&t.parentNode&&t.parentNode.removeChild(t)}function u(t,e,o){var s,i,n,l={};for(n in e)n=="key"?s=e[n]:n=="ref"?i=e[n]:l[n]=e[n];if(arguments.length>2&&(l.children=arguments.length>3?G.call(arguments,2):o),typeof t=="function"&&t.defaultProps!=null)for(n in t.defaultProps)l[n]===void 0&&(l[n]=t.defaultProps[n]);return J(t,l,s,i,null)}function J(t,e,o,s,i){var n={type:t,props:e,key:o,ref:s,__k:null,__:null,__b:0,__e:null,__c:null,constructor:void 0,__v:i??++me,__i:-1,__u:0};return i==null&&b.vnode!=null&&b.vnode(n),n}function $(t){return t.children}function V(t,e){this.props=t,this.context=e}function U(t,e){if(e==null)return t.__?U(t.__,t.__i+1):null;for(var o;e<t.__k.length;e++)if((o=t.__k[e])!=null&&o.__e!=null)return o.__e;return typeof t.type=="function"?U(t):null}function at(t){if(t.__P&&t.__d){var e=t.__v,o=e.__e,s=[],i=[],n=D({},e);n.__v=e.__v+1,b.vnode&&b.vnode(n),ae(t.__P,n,e,t.__n,t.__P.namespaceURI,32&e.__u?[o]:null,s,o??U(e),!!(32&e.__u),i),n.__v=e.__v,n.__.__k[n.__i]=n,Se(s,n,i),e.__e=e.__=null,n.__e!=o&&xe(n)}}function xe(t){if((t=t.__)!=null&&t.__c!=null)return t.__e=t.__c.base=null,t.__k.some(function(e){if(e!=null&&e.__e!=null)return t.__e=t.__c.base=e.__e}),xe(t)}function fe(t){(!t.__d&&(t.__d=!0)&&O.push(t)&&!Y.__r++||de!=b.debounceRendering)&&((de=b.debounceRendering)||ve)(Y)}function Y(){try{for(var t,e=1;O.length;)O.length>e&&O.sort(ye),t=O.shift(),e=O.length,at(t)}finally{O.length=Y.__r=0}}function ke(t,e,o,s,i,n,l,_,f,a,d){var r,p,c,g,h,y,m,v=s&&s.__k||K,S=e.length;for(f=lt(o,e,v,f,S),r=0;r<S;r++)(c=o.__k[r])!=null&&(p=c.__i!=-1&&v[c.__i]||Q,c.__i=r,y=ae(t,c,p,i,n,l,_,f,a,d),g=c.__e,c.ref&&p.ref!=c.ref&&(p.ref&&le(p.ref,null,c),d.push(c.ref,c.__c||g,c)),h==null&&g!=null&&(h=g),(m=!!(4&c.__u))||p.__k===c.__k?f=we(c,f,t,m):typeof c.type=="function"&&y!==void 0?f=y:g&&(f=g.nextSibling),c.__u&=-7);return o.__e=h,f}function lt(t,e,o,s,i){var n,l,_,f,a,d=o.length,r=d,p=0;for(t.__k=new Array(i),n=0;n<i;n++)(l=e[n])!=null&&typeof l!="boolean"&&typeof l!="function"?(typeof l=="string"||typeof l=="number"||typeof l=="bigint"||l.constructor==String?l=t.__k[n]=J(null,l,null,null,null):X(l)?l=t.__k[n]=J($,{children:l},null,null,null):l.constructor===void 0&&l.__b>0?l=t.__k[n]=J(l.type,l.props,l.key,l.ref?l.ref:null,l.__v):t.__k[n]=l,f=n+p,l.__=t,l.__b=t.__b+1,_=null,(a=l.__i=ct(l,o,f,r))!=-1&&(r--,(_=o[a])&&(_.__u|=2)),_==null||_.__v==null?(a==-1&&(i>d?p--:i<d&&p++),typeof l.type!="function"&&(l.__u|=4)):a!=f&&(a==f-1?p--:a==f+1?p++:(a>f?p--:p++,l.__u|=4))):t.__k[n]=null;if(r)for(n=0;n<d;n++)(_=o[n])!=null&&!(2&_.__u)&&(_.__e==s&&(s=U(_)),Me(_,_));return s}function we(t,e,o,s){var i,n;if(typeof t.type=="function"){for(i=t.__k,n=0;i&&n<i.length;n++)i[n]&&(i[n].__=t,e=we(i[n],e,o,s));return e}t.__e!=e&&(s&&(e&&t.type&&!e.parentNode&&(e=U(t)),o.insertBefore(t.__e,e||null)),e=t.__e);do e=e&&e.nextSibling;while(e!=null&&e.nodeType==8);return e}function ct(t,e,o,s){var i,n,l,_=t.key,f=t.type,a=e[o],d=a!=null&&(2&a.__u)==0;if(a===null&&_==null||d&&_==a.key&&f==a.type)return o;if(s>(d?1:0)){for(i=o-1,n=o+1;i>=0||n<e.length;)if((a=e[l=i>=0?i--:n++])!=null&&!(2&a.__u)&&_==a.key&&f==a.type)return l}return-1}function he(t,e,o){e[0]=="-"?t.setProperty(e,o??""):t[e]=o==null?"":typeof o!="number"||it.test(e)?o:o+"px"}function q(t,e,o,s,i){var n,l;e:if(e=="style")if(typeof o=="string")t.style.cssText=o;else{if(typeof s=="string"&&(t.style.cssText=s=""),s)for(e in s)o&&e in o||he(t.style,e,"");if(o)for(e in o)s&&o[e]==s[e]||he(t.style,e,o[e])}else if(e[0]=="o"&&e[1]=="n")n=e!=(e=e.replace(be,"$1")),l=e.toLowerCase(),e=l in t||e=="onFocusOut"||e=="onFocusIn"?l.slice(2):e.slice(2),t.l||(t.l={}),t.l[e+n]=o,o?s?o.u=s.u:(o.u=se,t.addEventListener(e,n?ne:oe,n)):t.removeEventListener(e,n?ne:oe,n);else{if(i=="http://www.w3.org/2000/svg")e=e.replace(/xlink(H|:h)/,"h").replace(/sName$/,"s");else if(e!="width"&&e!="height"&&e!="href"&&e!="list"&&e!="form"&&e!="tabIndex"&&e!="download"&&e!="rowSpan"&&e!="colSpan"&&e!="role"&&e!="popover"&&e in t)try{t[e]=o??"";break e}catch{}typeof o=="function"||(o==null||o===!1&&e[4]!="-"?t.removeAttribute(e):t.setAttribute(e,e=="popover"&&o==1?"":o))}}function ge(t){return function(e){if(this.l){var o=this.l[e.type+t];if(e.t==null)e.t=se++;else if(e.t<o.u)return;return o(b.event?b.event(e):e)}}}function ae(t,e,o,s,i,n,l,_,f,a){var d,r,p,c,g,h,y,m,v,S,k,P,M,A,N,C=e.type;if(e.constructor!==void 0)return null;128&o.__u&&(f=!!(32&o.__u),n=[_=e.__e=o.__e]),(d=b.__b)&&d(e);e:if(typeof C=="function")try{if(m=e.props,v=C.prototype&&C.prototype.render,S=(d=C.contextType)&&s[d.__c],k=d?S?S.props.value:d.__:s,o.__c?y=(r=e.__c=o.__c).__=r.__E:(v?e.__c=r=new C(m,k):(e.__c=r=new V(m,k),r.constructor=C,r.render=_t),S&&S.sub(r),r.state||(r.state={}),r.__n=s,p=r.__d=!0,r.__h=[],r._sb=[]),v&&r.__s==null&&(r.__s=r.state),v&&C.getDerivedStateFromProps!=null&&(r.__s==r.state&&(r.__s=D({},r.__s)),D(r.__s,C.getDerivedStateFromProps(m,r.__s))),c=r.props,g=r.state,r.__v=e,p)v&&C.getDerivedStateFromProps==null&&r.componentWillMount!=null&&r.componentWillMount(),v&&r.componentDidMount!=null&&r.__h.push(r.componentDidMount);else{if(v&&C.getDerivedStateFromProps==null&&m!==c&&r.componentWillReceiveProps!=null&&r.componentWillReceiveProps(m,k),e.__v==o.__v||!r.__e&&r.shouldComponentUpdate!=null&&r.shouldComponentUpdate(m,r.__s,k)===!1){e.__v!=o.__v&&(r.props=m,r.state=r.__s,r.__d=!1),e.__e=o.__e,e.__k=o.__k,e.__k.some(function(L){L&&(L.__=e)}),K.push.apply(r.__h,r._sb),r._sb=[],r.__h.length&&l.push(r);break e}r.componentWillUpdate!=null&&r.componentWillUpdate(m,r.__s,k),v&&r.componentDidUpdate!=null&&r.__h.push(function(){r.componentDidUpdate(c,g,h)})}if(r.context=k,r.props=m,r.__P=t,r.__e=!1,P=b.__r,M=0,v)r.state=r.__s,r.__d=!1,P&&P(e),d=r.render(r.props,r.state,r.context),K.push.apply(r.__h,r._sb),r._sb=[];else do r.__d=!1,P&&P(e),d=r.render(r.props,r.state,r.context),r.state=r.__s;while(r.__d&&++M<25);r.state=r.__s,r.getChildContext!=null&&(s=D(D({},s),r.getChildContext())),v&&!p&&r.getSnapshotBeforeUpdate!=null&&(h=r.getSnapshotBeforeUpdate(c,g)),A=d!=null&&d.type===$&&d.key==null?Ce(d.props.children):d,_=ke(t,X(A)?A:[A],e,o,s,i,n,l,_,f,a),r.base=e.__e,e.__u&=-161,r.__h.length&&l.push(r),y&&(r.__E=r.__=null)}catch(L){if(e.__v=null,f||n!=null)if(L.then){for(e.__u|=f?160:128;_&&_.nodeType==8&&_.nextSibling;)_=_.nextSibling;n[n.indexOf(_)]=null,e.__e=_}else{for(N=n.length;N--;)ie(n[N]);re(e)}else e.__e=o.__e,e.__k=o.__k,L.then||re(e);b.__e(L,e,o)}else n==null&&e.__v==o.__v?(e.__k=o.__k,e.__e=o.__e):_=e.__e=ut(o.__e,e,o,s,i,n,l,f,a);return(d=b.diffed)&&d(e),128&e.__u?void 0:_}function re(t){t&&(t.__c&&(t.__c.__e=!0),t.__k&&t.__k.some(re))}function Se(t,e,o){for(var s=0;s<o.length;s++)le(o[s],o[++s],o[++s]);b.__c&&b.__c(e,t),t.some(function(i){try{t=i.__h,i.__h=[],t.some(function(n){n.call(i)})}catch(n){b.__e(n,i.__v)}})}function Ce(t){return typeof t!="object"||t==null||t.__b>0?t:X(t)?t.map(Ce):D({},t)}function ut(t,e,o,s,i,n,l,_,f){var a,d,r,p,c,g,h,y=o.props||Q,m=e.props,v=e.type;if(v=="svg"?i="http://www.w3.org/2000/svg":v=="math"?i="http://www.w3.org/1998/Math/MathML":i||(i="http://www.w3.org/1999/xhtml"),n!=null){for(a=0;a<n.length;a++)if((c=n[a])&&"setAttribute"in c==!!v&&(v?c.localName==v:c.nodeType==3)){t=c,n[a]=null;break}}if(t==null){if(v==null)return document.createTextNode(m);t=document.createElementNS(i,v,m.is&&m),_&&(b.__m&&b.__m(e,n),_=!1),n=null}if(v==null)y===m||_&&t.data==m||(t.data=m);else{if(n=n&&G.call(t.childNodes),!_&&n!=null)for(y={},a=0;a<t.attributes.length;a++)y[(c=t.attributes[a]).name]=c.value;for(a in y)c=y[a],a=="dangerouslySetInnerHTML"?r=c:a=="children"||a in m||a=="value"&&"defaultValue"in m||a=="checked"&&"defaultChecked"in m||q(t,a,null,c,i);for(a in m)c=m[a],a=="children"?p=c:a=="dangerouslySetInnerHTML"?d=c:a=="value"?g=c:a=="checked"?h=c:_&&typeof c!="function"||y[a]===c||q(t,a,c,y[a],i);if(d)_||r&&(d.__html==r.__html||d.__html==t.innerHTML)||(t.innerHTML=d.__html),e.__k=[];else if(r&&(t.innerHTML=""),ke(e.type=="template"?t.content:t,X(p)?p:[p],e,o,s,v=="foreignObject"?"http://www.w3.org/1999/xhtml":i,n,l,n?n[0]:o.__k&&U(o,0),_,f),n!=null)for(a=n.length;a--;)ie(n[a]);_||(a="value",v=="progress"&&g==null?t.removeAttribute("value"):g!=null&&(g!==t[a]||v=="progress"&&!g||v=="option"&&g!=y[a])&&q(t,a,g,y[a],i),a="checked",h!=null&&h!=t[a]&&q(t,a,h,y[a],i))}return t}function le(t,e,o){try{if(typeof t=="function"){var s=typeof t.__u=="function";s&&t.__u(),s&&e==null||(t.__u=t(e))}else t.current=e}catch(i){b.__e(i,o)}}function Me(t,e,o){var s,i;if(b.unmount&&b.unmount(t),(s=t.ref)&&(s.current&&s.current!=t.__e||le(s,null,e)),(s=t.__c)!=null){if(s.componentWillUnmount)try{s.componentWillUnmount()}catch(n){b.__e(n,e)}s.base=s.__P=null}if(s=t.__k)for(i=0;i<s.length;i++)s[i]&&Me(s[i],e,o||typeof t.type!="function");o||ie(t.__e),t.__c=t.__=t.__e=void 0}function _t(t,e,o){return this.constructor(t,o)}function Ie(t,e,o){var s,i,n,l;e==document&&(e=document.documentElement),b.__&&b.__(t,e),i=(s=typeof o=="function")?null:o&&o.__k||e.__k,n=[],l=[],ae(e,t=(!s&&o||e).__k=u($,null,[t]),i||Q,Q,e.namespaceURI,!s&&o?[o]:i?null:e.firstChild?G.call(e.childNodes):null,n,!s&&o?o:i?i.__e:e.firstChild,s,l),Se(n,t,l)}var G,b,me,rt,O,de,ve,ye,be,se,oe,ne,st,Q,K,it,X,B=H(()=>{Q={},K=[],it=/acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i,X=Array.isArray;G=K.slice,b={__e:function(t,e,o,s){for(var i,n,l;e=e.__;)if((i=e.__c)&&!i.__)try{if((n=i.constructor)&&n.getDerivedStateFromError!=null&&(i.setState(n.getDerivedStateFromError(t)),l=i.__d),i.componentDidCatch!=null&&(i.componentDidCatch(t,s||{}),l=i.__d),l)return i.__E=i}catch(_){t=_}throw t}},me=0,rt=function(t){return t!=null&&t.constructor===void 0},V.prototype.setState=function(t,e){var o;o=this.__s!=null&&this.__s!=this.state?this.__s:this.__s=D({},this.state),typeof t=="function"&&(t=t(D({},o),this.props)),t&&D(o,t),t!=null&&this.__v&&(e&&this._sb.push(e),fe(this))},V.prototype.forceUpdate=function(t){this.__v&&(this.__e=!0,t&&this.__h.push(t),fe(this))},V.prototype.render=$,O=[],ve=typeof Promise=="function"?Promise.prototype.then.bind(Promise.resolve()):setTimeout,ye=function(t,e){return t.__v.__b-e.__v.__b},Y.__r=0,be=/(PointerCapture)$|Capture$/i,se=0,oe=ge(!1),ne=ge(!0),st=0});var Ee,Te=H(()=>{Ee=`/* Scout Widget \u2014 Shadow DOM stylesheet\r
   All styles are scoped to the Shadow DOM automatically.\r
   This file is loaded as text by esbuild and injected as a <style> tag.\r
*/\r
\r
/* ===== Reset (Shadow DOM only \u2014 does not affect host page) ===== */\r
*, *::before, *::after {\r
  box-sizing: border-box;\r
  margin: 0;\r
  padding: 0;\r
  font-family: var(--scout-font);\r
}\r
\r
/* ===== Design tokens ===== */\r
:host, :root {\r
  --scout-primary: #153640;\r
  --scout-primary-hover: #1e4a58;\r
  --scout-bg: #ffffff;\r
  --scout-bg-message: #f3f4f6;\r
  --scout-text: #1f2937;\r
  --scout-text-light: #6b7280;\r
  --scout-border: #e5e7eb;\r
  --scout-radius: 16px;\r
  --scout-shadow: 0 4px 24px rgba(0, 0, 0, 0.12);\r
  --scout-font: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\r
}\r
\r
/* ===== Keyframe animations ===== */\r
@keyframes slideUp {\r
  from {\r
    transform: translateY(20px);\r
    opacity: 0;\r
  }\r
  to {\r
    transform: translateY(0);\r
    opacity: 1;\r
  }\r
}\r
\r
@keyframes scout-pulse {\r
  0% {\r
    box-shadow: 0 0 0 0 rgba(21, 54, 64, 0.5);\r
  }\r
  70% {\r
    box-shadow: 0 0 0 12px rgba(21, 54, 64, 0);\r
  }\r
  100% {\r
    box-shadow: 0 0 0 0 rgba(21, 54, 64, 0);\r
  }\r
}\r
\r
@keyframes scout-dot-bounce {\r
  0%, 80%, 100% {\r
    transform: translateY(0);\r
    opacity: 0.4;\r
  }\r
  40% {\r
    transform: translateY(-6px);\r
    opacity: 1;\r
  }\r
}\r
\r
/* ===== FAB \u2014 Floating Action Button ===== */\r
.scout-fab {\r
  position: fixed;\r
  bottom: 90px;\r
  right: 30px;\r
  width: 60px;\r
  height: 60px;\r
  border-radius: 50%;\r
  background: var(--scout-primary);\r
  color: #ffffff;\r
  border: none;\r
  outline: none;\r
  cursor: pointer;\r
  display: flex;\r
  align-items: center;\r
  justify-content: center;\r
  box-shadow: 0 2px 12px rgba(21, 54, 64, 0.4);\r
  pointer-events: auto;\r
  transition: transform 0.2s ease, box-shadow 0.2s ease;\r
  z-index: 1;\r
}\r
\r
.scout-fab:hover {\r
  transform: scale(1.05);\r
  box-shadow: 0 4px 20px rgba(21, 54, 64, 0.5);\r
}\r
\r
.scout-fab:active {\r
  transform: scale(0.97);\r
}\r
\r
/* ===== FAB pulse animation (first load) ===== */\r
.scout-fab-pulse {\r
  animation: scout-pulse 1.5s ease-out 3;\r
}\r
\r
/* ===== Chat panel ===== */\r
.scout-panel {\r
  position: fixed;\r
  bottom: 160px;\r
  right: 24px;\r
  width: 380px;\r
  max-height: 520px;\r
  background: var(--scout-bg);\r
  border-radius: var(--scout-radius);\r
  box-shadow: var(--scout-shadow);\r
  display: flex;\r
  flex-direction: column;\r
  overflow: hidden;\r
  pointer-events: auto;\r
  animation: slideUp 0.25s ease-out;\r
  z-index: 1;\r
}\r
\r
/* ===== Panel header ===== */\r
.scout-panel-header {\r
  padding: 16px;\r
  background: var(--scout-primary);\r
  color: #ffffff;\r
  font-weight: 600;\r
  font-size: 15px;\r
  display: flex;\r
  align-items: center;\r
  gap: 8px;\r
  border-radius: var(--scout-radius) var(--scout-radius) 0 0;\r
  flex-shrink: 0;\r
}\r
\r
.scout-panel-header-left {\r
  flex: 1;\r
  min-width: 0;\r
}\r
\r
.scout-panel-header-title {\r
  /* title within left area */\r
}\r
\r
.scout-panel-header-actions {\r
  display: flex;\r
  align-items: center;\r
  gap: 4px;\r
  flex-shrink: 0;\r
}\r
\r
/* ===== Escape hatch \u2014 Talk to a person button ===== */\r
.scout-human-btn {\r
  background: none;\r
  border: 1px solid rgba(255,255,255,0.6);\r
  color: #ffffff;\r
  cursor: pointer;\r
  padding: 4px 10px;\r
  border-radius: 12px;\r
  font-size: 11px;\r
  font-weight: 500;\r
  display: flex;\r
  align-items: center;\r
  gap: 4px;\r
  white-space: nowrap;\r
  transition: background 0.15s ease;\r
  flex-shrink: 0;\r
}\r
\r
.scout-human-btn:hover {\r
  background: rgba(255,255,255,0.15);\r
}\r
\r
/* On narrow panels, show icon only */\r
@media (max-width: 360px) {\r
  .scout-human-btn-text {\r
    display: none;\r
  }\r
}\r
\r
/* ===== Close button ===== */\r
.scout-close-btn {\r
  background: none;\r
  border: none;\r
  color: #ffffff;\r
  cursor: pointer;\r
  padding: 4px;\r
  display: flex;\r
  align-items: center;\r
  justify-content: center;\r
  border-radius: 4px;\r
  opacity: 0.85;\r
  transition: opacity 0.15s;\r
  flex-shrink: 0;\r
}\r
\r
.scout-close-btn:hover {\r
  opacity: 1;\r
}\r
\r
/* ===== Messages container ===== */\r
.scout-messages {\r
  flex: 1;\r
  overflow-y: auto;\r
  padding: 16px;\r
  display: flex;\r
  flex-direction: column;\r
  gap: 12px;\r
  scrollbar-width: thin;\r
  scrollbar-color: var(--scout-border) transparent;\r
}\r
\r
.scout-messages::-webkit-scrollbar {\r
  width: 4px;\r
}\r
\r
.scout-messages::-webkit-scrollbar-track {\r
  background: transparent;\r
}\r
\r
.scout-messages::-webkit-scrollbar-thumb {\r
  background: var(--scout-border);\r
  border-radius: 2px;\r
}\r
\r
/* ===== Individual messages ===== */\r
.scout-message {\r
  max-width: 85%;\r
  padding: 10px 14px;\r
  border-radius: 12px;\r
  font-size: 14px;\r
  line-height: 1.5;\r
  word-break: break-word;\r
}\r
\r
.scout-message--assistant {\r
  background: var(--scout-bg-message);\r
  color: var(--scout-text);\r
  align-self: flex-start;\r
  display: flex;\r
  gap: 8px;\r
}\r
\r
/* Markdown rendering inside assistant messages */\r
.scout-message-text strong {\r
  font-weight: 600;\r
}\r
\r
.scout-message-text ul {\r
  margin: 6px 0;\r
  padding-left: 16px;\r
  list-style: disc;\r
}\r
\r
.scout-message-text li {\r
  margin: 2px 0;\r
}\r
\r
.scout-link {\r
  color: var(--scout-primary);\r
  text-decoration: underline;\r
  text-underline-offset: 2px;\r
  word-break: break-all;\r
}\r
\r
.scout-link:hover {\r
  color: var(--scout-primary-hover);\r
}\r
\r
.scout-btn-link {\r
  display: inline-block;\r
  margin: 8px 0 4px;\r
  padding: 10px 20px;\r
  background: var(--scout-primary);\r
  color: #fff;\r
  border-radius: 8px;\r
  text-decoration: none;\r
  font-weight: 600;\r
  font-size: 14px;\r
  transition: background 0.15s;\r
}\r
\r
.scout-btn-link:hover {\r
  background: var(--scout-primary-hover);\r
  color: #fff;\r
}\r
\r
.scout-message--user {\r
  background: var(--scout-primary);\r
  color: #ffffff;\r
  align-self: flex-end;\r
}\r
\r
/* ===== Avatar (for assistant messages) ===== */\r
.scout-avatar {\r
  width: 28px;\r
  height: 28px;\r
  border-radius: 50%;\r
  flex-shrink: 0;\r
  background: var(--scout-primary);\r
  display: flex;\r
  align-items: center;\r
  justify-content: center;\r
  font-size: 14px;\r
}\r
\r
/* ===== Typing indicator ===== */\r
.scout-typing {\r
  display: flex;\r
  gap: 4px;\r
  padding: 10px 14px;\r
  background: var(--scout-bg-message);\r
  border-radius: 12px;\r
  align-self: flex-start;\r
  pointer-events: none;\r
}\r
\r
.scout-typing span {\r
  width: 6px;\r
  height: 6px;\r
  border-radius: 50%;\r
  background: var(--scout-text-light);\r
  display: inline-block;\r
  animation: scout-dot-bounce 1.2s ease-in-out infinite;\r
}\r
\r
.scout-typing span:nth-child(2) {\r
  animation-delay: 0.2s;\r
}\r
\r
.scout-typing span:nth-child(3) {\r
  animation-delay: 0.4s;\r
}\r
\r
/* ===== Quick replies ===== */\r
.scout-quick-replies {\r
  display: flex;\r
  flex-wrap: wrap;\r
  gap: 8px;\r
  padding: 8px 16px;\r
  flex-shrink: 0;\r
}\r
\r
.scout-quick-reply {\r
  background: #ffffff;\r
  border: 1px solid var(--scout-primary);\r
  color: var(--scout-primary);\r
  border-radius: 16px;\r
  padding: 6px 14px;\r
  font-size: 13px;\r
  cursor: pointer;\r
  transition: background 0.15s ease, color 0.15s ease;\r
  line-height: 1.4;\r
}\r
\r
.scout-quick-reply:hover {\r
  background: var(--scout-primary);\r
  color: #ffffff;\r
}\r
\r
/* ===== Input area ===== */\r
.scout-input-area {\r
  padding: 12px 16px;\r
  border-top: 1px solid var(--scout-border);\r
  display: flex;\r
  gap: 8px;\r
  align-items: center;\r
  flex-shrink: 0;\r
}\r
\r
.scout-input {\r
  flex: 1;\r
  border: 1px solid var(--scout-border);\r
  border-radius: 20px;\r
  padding: 8px 16px;\r
  font-size: 14px;\r
  font-family: var(--scout-font);\r
  outline: none;\r
  transition: border-color 0.2s ease;\r
  background: #ffffff;\r
  color: var(--scout-text);\r
  resize: none;\r
}\r
\r
.scout-input:focus {\r
  border-color: var(--scout-primary);\r
}\r
\r
.scout-input::placeholder {\r
  color: var(--scout-text-light);\r
}\r
\r
.scout-send-btn {\r
  width: 36px;\r
  height: 36px;\r
  border-radius: 50%;\r
  background: var(--scout-primary);\r
  border: none;\r
  cursor: pointer;\r
  color: #ffffff;\r
  display: flex;\r
  align-items: center;\r
  justify-content: center;\r
  flex-shrink: 0;\r
  transition: background 0.15s ease;\r
}\r
\r
.scout-send-btn:hover {\r
  background: var(--scout-primary-hover);\r
}\r
\r
.scout-send-btn:disabled {\r
  opacity: 0.5;\r
  cursor: not-allowed;\r
}\r
\r
/* ===== Mobile responsive ===== */\r
@media (max-width: 480px) {\r
  .scout-panel {\r
    width: calc(100vw - 16px);\r
    right: 8px;\r
    bottom: 144px;\r
    max-height: calc(100vh - 180px);\r
  }\r
\r
  .scout-fab {\r
    bottom: 80px;\r
    right: 16px;\r
    width: 48px;\r
    height: 48px;\r
  }\r
}\r
`});function _e(t,e){w.__h&&w.__h(x,t,ee||e),ee=0;var o=x.__H||(x.__H={__:[],__h:[]});return t>=o.__.length&&o.__.push({}),o.__[t]}function T(t){return ee=1,dt($e,t)}function dt(t,e,o){var s=_e(W++,2);if(s.t=t,!s.__c&&(s.__=[o?o(e):$e(void 0,e),function(_){var f=s.__N?s.__N[0]:s.__[0],a=s.t(f,_);f!==a&&(s.__N=[a,s.__[1]],s.__c.setState({}))}],s.__c=x,!x.__f)){var i=function(_,f,a){if(!s.__c.__H)return!0;var d=s.__c.__H.__.filter(function(p){return p.__c});if(d.every(function(p){return!p.__N}))return!n||n.call(this,_,f,a);var r=s.__c.props!==_;return d.some(function(p){if(p.__N){var c=p.__[0];p.__=p.__N,p.__N=void 0,c!==p.__[0]&&(r=!0)}}),n&&n.call(this,_,f,a)||r};x.__f=!0;var n=x.shouldComponentUpdate,l=x.componentWillUpdate;x.componentWillUpdate=function(_,f,a){if(this.__e){var d=n;n=void 0,i(_,f,a),n=d}l&&l.call(this,_,f,a)},x.shouldComponentUpdate=i}return s.__N||s.__}function R(t,e){var o=_e(W++,3);!w.__s&&Ue(o.__H,e)&&(o.__=t,o.u=e,x.__H.__h.push(o))}function te(t){return ee=5,ft(function(){return{current:t}},[])}function ft(t,e){var o=_e(W++,7);return Ue(o.__H,e)&&(o.__=t(),o.__H=e,o.__h=t),o.__}function ht(){for(var t;t=Re.shift();){var e=t.__H;if(t.__P&&e)try{e.__h.some(Z),e.__h.some(ue),e.__h=[]}catch(o){e.__h=[],w.__e(o,t.__v)}}}function gt(t){var e,o=function(){clearTimeout(s),Be&&cancelAnimationFrame(e),setTimeout(t)},s=setTimeout(o,35);Be&&(e=requestAnimationFrame(o))}function Z(t){var e=x,o=t.__c;typeof o=="function"&&(t.__c=void 0,o()),x=e}function ue(t){var e=x;t.__c=t.__(),x=e}function Ue(t,e){return!t||t.length!==e.length||e.some(function(o,s){return o!==t[s]})}function $e(t,e){return typeof e=="function"?e(t):e}var W,x,ce,Ne,ee,Re,w,He,Pe,De,Ae,Le,Oe,Be,j=H(()=>{B();ee=0,Re=[],w=b,He=w.__b,Pe=w.__r,De=w.diffed,Ae=w.__c,Le=w.unmount,Oe=w.__;w.__b=function(t){x=null,He&&He(t)},w.__=function(t,e){t&&e.__k&&e.__k.__m&&(t.__m=e.__k.__m),Oe&&Oe(t,e)},w.__r=function(t){Pe&&Pe(t),W=0;var e=(x=t.__c).__H;e&&(ce===x?(e.__h=[],x.__h=[],e.__.some(function(o){o.__N&&(o.__=o.__N),o.u=o.__N=void 0})):(e.__h.some(Z),e.__h.some(ue),e.__h=[],W=0)),ce=x},w.diffed=function(t){De&&De(t);var e=t.__c;e&&e.__H&&(e.__H.__h.length&&(Re.push(e)!==1&&Ne===w.requestAnimationFrame||((Ne=w.requestAnimationFrame)||gt)(ht)),e.__H.__.some(function(o){o.u&&(o.__H=o.u),o.u=void 0})),ce=x=null},w.__c=function(t,e){e.some(function(o){try{o.__h.some(Z),o.__h=o.__h.filter(function(s){return!s.__||ue(s)})}catch(s){e.some(function(i){i.__h&&(i.__h=[])}),e=[],w.__e(s,o.__v)}}),Ae&&Ae(t,e)},w.unmount=function(t){Le&&Le(t);var e,o=t.__c;o&&o.__H&&(o.__H.__.some(function(s){try{Z(s)}catch(i){e=i}}),o.__H=void 0,e&&w.__e(e,o.__v))};Be=typeof requestAnimationFrame=="function"});function Fe({onClick:t,isOpen:e,hasNewMessage:o}){let s=te(null);return R(()=>{let i=s.current;if(!i)return;let n=setTimeout(()=>{i.classList.remove("scout-fab-pulse")},3e3);return()=>clearTimeout(n)},[]),u("button",{ref:s,class:`scout-fab${e?"":" scout-fab-pulse"}`,onClick:t,"aria-label":"Chat with Scout","aria-expanded":e?"true":"false"},e?u("svg",{width:"20",height:"20",viewBox:"0 0 20 20",fill:"none",xmlns:"http://www.w3.org/2000/svg","aria-hidden":"true"},u("path",{d:"M15 5L5 15M5 5L15 15",stroke:"currentColor","stroke-width":"2","stroke-linecap":"round"})):u("svg",{width:"28",height:"28",viewBox:"0 0 28 28",fill:"none",xmlns:"http://www.w3.org/2000/svg","aria-hidden":"true"},u("circle",{cx:"9",cy:"14",r:"5.5",stroke:"currentColor","stroke-width":"2",fill:"none"}),u("circle",{cx:"19",cy:"14",r:"5.5",stroke:"currentColor","stroke-width":"2",fill:"none"}),u("path",{d:"M14.5 12.5C14 11.5 13 11.5 12.5 12.5",stroke:"currentColor","stroke-width":"1.5","stroke-linecap":"round",fill:"none"}),u("path",{d:"M3.5 14L1 11",stroke:"currentColor","stroke-width":"1.5","stroke-linecap":"round"}),u("path",{d:"M24.5 14L27 11",stroke:"currentColor","stroke-width":"1.5","stroke-linecap":"round"})))}var ze=H(()=>{B();j()});function mt(t){if(!t)return"";let e=t.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");return e=e.replace(/\[([^\]]+)\]\((https?:\/\/[^)]+)\)/g,(o,s,i)=>/sizing-tool/i.test(i)?`<a href="${i}" target="_blank" rel="noopener noreferrer" class="scout-btn-link">${s}</a>`:`<a href="${i}" target="_blank" rel="noopener noreferrer" class="scout-link">${s}</a>`),e=e.replace(/(?<!="|'\/)(https?:\/\/[^\s<]+)/g,'<a href="$1" target="_blank" rel="noopener noreferrer" class="scout-link">$1</a>'),e=e.replace(/\*\*(.+?)\*\*/g,"<strong>$1</strong>"),e=e.replace(/^[•\-]\s+(.+)$/gm,"<li>$1</li>"),e=e.replace(/((?:<li>.*<\/li>\n?)+)/g,"<ul>$1</ul>"),e=e.replace(/\n/g,"<br />"),e=e.replace(/<br \/>\s*<ul>/g,"<ul>"),e=e.replace(/<\/ul>\s*<br \/>/g,"</ul>"),e=e.replace(/<\/li><br \/>/g,"</li>"),e}function We({role:t,content:e,isStreaming:o}){return t==="assistant"?u("div",{class:"scout-message scout-message--assistant"},u("div",{class:"scout-avatar","aria-hidden":"true"},u("svg",{width:"28",height:"28",viewBox:"0 0 28 28",fill:"none",xmlns:"http://www.w3.org/2000/svg"},u("circle",{cx:"14",cy:"14",r:"14",fill:"#153640"}),u("circle",{cx:"10",cy:"14",r:"4",stroke:"white","stroke-width":"1.5",fill:"none"}),u("circle",{cx:"18",cy:"14",r:"4",stroke:"white","stroke-width":"1.5",fill:"none"}),u("path",{d:"M14 12.5c-.3-.7-1-.7-1.3 0",stroke:"white","stroke-width":"1","stroke-linecap":"round",fill:"none"}),u("path",{d:"M6 14L4 11.5",stroke:"white","stroke-width":"1","stroke-linecap":"round"}),u("path",{d:"M22 14L24 11.5",stroke:"white","stroke-width":"1","stroke-linecap":"round"}))),u("div",{class:"scout-message-text",dangerouslySetInnerHTML:{__html:mt(e)+(o?'<span class="scout-cursor" aria-hidden="true">|</span>':"")}})):u("div",{class:"scout-message scout-message--user"},e)}var je=H(()=>{B()});function qe({options:t,onSelect:e}){return!t||t.length===0?null:u("div",{class:"scout-quick-replies",role:"group","aria-label":"Quick reply options"},t.map(o=>u("button",{key:o.value,class:"scout-quick-reply",onClick:()=>e(o),type:"button"},o.label)))}var Je=H(()=>{B()});function Ve({messages:t,onSend:e,onQuickReply:o,onClose:s,quickReplies:i,isStreaming:n,schoolCode:l,customerName:_,isLoading:f,streamingText:a}){let[d,r]=T(""),p=te(null);R(()=>{p.current&&(p.current.scrollTop=p.current.scrollHeight)},[t.length,a]);function c(){let h=d.trim();!h||n||(r(""),e(h))}function g(h){h.key==="Enter"&&!h.shiftKey&&(h.preventDefault(),c())}return u("div",{class:"scout-panel",role:"dialog","aria-label":"Scout assistant"},u("div",{class:"scout-panel-header"},u("div",{class:"scout-panel-header-left"},u("div",{class:"scout-panel-header-title"},u("svg",{width:"20",height:"20",viewBox:"0 0 28 28",fill:"none",xmlns:"http://www.w3.org/2000/svg","aria-hidden":"true",style:"vertical-align: middle; margin-right: 6px;"},u("circle",{cx:"14",cy:"14",r:"14",fill:"#4A90D9"}),u("path",{d:"M7 8h14a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H9l-3 2.5V9a1 1 0 0 1 1-1z",fill:"white"}),u("circle",{cx:"11",cy:"13",r:"1.2",fill:"#4A90D9"}),u("circle",{cx:"14",cy:"13",r:"1.2",fill:"#4A90D9"}),u("circle",{cx:"17",cy:"13",r:"1.2",fill:"#4A90D9"})),"Scout"),_&&u("div",{class:"scout-panel-header-subtitle"},"Hi ",_,"!")),u("div",{class:"scout-panel-header-actions"},u("button",{class:"scout-human-btn",onClick:()=>e("I want to talk to a real person"),type:"button","aria-label":"Talk to a person",title:"Talk to a Max & Alice team member"},u("svg",{width:"14",height:"14",viewBox:"0 0 16 16",fill:"none",xmlns:"http://www.w3.org/2000/svg","aria-hidden":"true"},u("circle",{cx:"8",cy:"4",r:"3",stroke:"currentColor","stroke-width":"1.5",fill:"none"}),u("path",{d:"M2 14c0-3.3 2.7-6 6-6s6 2.7 6 6",stroke:"currentColor","stroke-width":"1.5",fill:"none","stroke-linecap":"round"})),u("span",{class:"scout-human-btn-text"},"Talk to a person")),u("button",{class:"scout-close-btn",onClick:s,"aria-label":"Close Scout",type:"button"},u("svg",{width:"16",height:"16",viewBox:"0 0 16 16",fill:"none",xmlns:"http://www.w3.org/2000/svg","aria-hidden":"true"},u("path",{d:"M12 4L4 12M4 4L12 12",stroke:"currentColor","stroke-width":"2","stroke-linecap":"round"}))))),u("div",{class:"scout-messages",ref:p},f?u("div",{class:"scout-connecting"},"Connecting..."):u($,null,t.map((h,y)=>{let m=y===t.length-1&&h.role==="assistant";return u(We,{key:y,role:h.role,content:m&&n?a:h.content,isStreaming:m&&n})}),n&&(t.length===0||t[t.length-1].role==="user")&&u("div",{class:"scout-typing","aria-label":"Scout is typing"},u("span",null),u("span",null),u("span",null)))),!n&&i&&i.length>0&&u(qe,{options:i,onSelect:o}),u("div",{class:"scout-input-area"},u("input",{class:"scout-input",type:"text",placeholder:"Ask about uniforms, sizing, orders...",value:d,onInput:h=>r(h.target.value),onKeyDown:g,disabled:f,"aria-label":"Message Scout"}),u("button",{class:"scout-send-btn",onClick:c,disabled:!d.trim()||n||f,"aria-label":"Send message",type:"button"},u("svg",{width:"18",height:"18",viewBox:"0 0 18 18",fill:"none",xmlns:"http://www.w3.org/2000/svg","aria-hidden":"true"},u("path",{d:"M16 2L2 9L8 11L10 17L16 2Z",fill:"currentColor",stroke:"currentColor","stroke-width":"1","stroke-linejoin":"round"})))))}var Qe=H(()=>{B();j();je();Je()});function Ye(t){let[e,o]=T(null),[s,i]=T(!0),[n,l]=T(null);R(()=>{async function a(){try{let r=sessionStorage.getItem(F);if(r){let p=JSON.parse(r);if(Date.now()-(p.createdAt||0)<25*60*1e3){o(p),i(!1);return}sessionStorage.removeItem(F)}}catch{sessionStorage.removeItem(F)}let d={};try{d=JSON.parse(localStorage.getItem(Ke)||"{}")}catch{}try{let r=await fetch(`${t.apiBase}/api/scout/session`,{method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify({tags:t.customerTags||[],customerId:t.customerId||null,collectionId:t.collectionId||null,rememberedSchoolCode:d.schoolCode||null})});if(!r.ok)throw new Error(`Session API returned ${r.status}`);let p=await r.json(),c=p.schoolCode||null,g=t.customerName||d.customerName||null,h={sessionId:p.sessionId,token:p.token,schoolCode:c,messages:[],customerName:g,createdAt:Date.now()};sessionStorage.setItem(F,JSON.stringify(h)),o(h);try{localStorage.setItem(Ke,JSON.stringify({schoolCode:c||d.schoolCode||null,customerName:g}))}catch{}}catch(r){console.warn("[Scout] Session init failed:",r.message),l(r.message)}finally{i(!1)}}a()},[]);function _(a,d){o(r=>{if(!r)return r;let p={...r,messages:a};d&&(p.pageType=d);try{sessionStorage.setItem(F,JSON.stringify(p))}catch(c){console.warn("[Scout] sessionStorage write failed:",c.message)}return p})}function f(){try{sessionStorage.removeItem(F)}catch{}o(null),l(null),i(!1)}return{session:e,loading:s,error:n,updateMessages:_,clearSession:f}}var F,Ke,Ge=H(()=>{j();F="scout_session",Ke="scout_remember"});async function Xe({apiBase:t,token:e,text:o,messages:s,onChunk:i,onDone:n,onQuickReplies:l,onError:_}){let f="";try{let a=await fetch(`${t}/api/scout/message`,{method:"POST",headers:{"Content-Type":"application/json","X-Scout-Session":e},body:JSON.stringify({text:o,messages:s})});if(!a.ok)throw new Error(`Message API returned ${a.status}`);let d=a.body.getReader(),r=new TextDecoder,p="";for(;;){let{done:c,value:g}=await d.read();if(c)break;p+=r.decode(g,{stream:!0});let h=p.split(`

`);p=h.pop();for(let y of h){let m=y.trim();if(!m)continue;let v=m.split(`
`).find(P=>P.startsWith("data: "));if(!v)continue;let S=v.slice(6);if(S==="[DONE]")continue;let k;try{k=JSON.parse(S)}catch{continue}if(k.type==="text-delta"&&typeof k.delta=="string")f+=k.delta,i(f);else if(k.type==="quick-replies"&&Array.isArray(k.options))l&&l(k.options);else if(k.type==="error")throw new Error(k.message||"Stream error")}}if(p.trim()){let g=p.trim().split(`
`).find(h=>h.startsWith("data: "));if(g){let h=g.slice(6);if(h!=="[DONE]")try{let y=JSON.parse(h);if(y.type==="text-delta"&&typeof y.delta=="string")f+=y.delta;else if(y.type==="error"){_(new Error(y.message||"Stream error"));return}}catch{}}}n(f)}catch(a){_(a)}}var Ze=H(()=>{});function vt(t){let e=t&&t.pageType||"index";if(e==="collection"){let o=t.collectionHandle?t.collectionHandle.replace(/-/g," "):null;return o?`Hi! I'm Scout. Browsing the ${o} collection \u2014 need help finding the right uniform?`:"Hi! I'm Scout. Need help finding the right uniform?"}return e==="product"?`Hi! I'm Scout. Want help picking the right size for ${t.productTitle||"this item"}?`:"Hi! I'm Scout. How can I help you today?"}function pe({pageContext:t}){let[e,o]=T(!1),[s,i]=T([]),[n,l]=T(!1),[_,f]=T(""),[a,d]=T([]),[r,p]=T(!1),{session:c,loading:g,error:h,updateMessages:y,clearSession:m}=Ye(t),v=t.pageType||"default";function S(M){y(M,v)}R(()=>{if(!e||r||g)return;let M=c?c.pageType:null,A=M&&M===v;if(c&&c.messages&&c.messages.length>0&&A){i(c.messages),p(!0);return}if(c){let C=[{role:"assistant",content:vt(t)}];i(C),S(C),p(!0),d(yt)}h&&(i([{role:"assistant",content:"Sorry, I couldn't connect right now. Please try again in a moment."}]),p(!0))},[e,c,g,h,r]);async function k(M){if(!c||n)return;let A={role:"user",content:M},N=[...s,A];i(N),S(N),d([]),l(!0),f("");let C=N.map(E=>({role:E.role,content:E.content})),L={role:"assistant",content:""},ot=[...N,L];i(ot),await Xe({apiBase:t.apiBase,token:c.token,text:M,messages:C,onChunk(E){f(E),i(z=>{let I=[...z];return I[I.length-1]={role:"assistant",content:E},I})},onQuickReplies(E){d(E)},onDone(E){l(!1),f(""),i(z=>{let I=[...z];return I[I.length-1]={role:"assistant",content:E},S(I),I})},onError(E){console.warn("[Scout] Stream error:",E.message),l(!1),f(""),i(z=>{let I=[...z];return I[I.length-1]={role:"assistant",content:"Sorry, something went wrong. Please try again."},S(I),I})}})}async function P(M){d([]),await k(M.value)}return u("div",null,e&&u(Ve,{messages:s,onSend:k,onQuickReply:P,onClose:()=>o(!1),quickReplies:a,isStreaming:n,streamingText:_,schoolCode:c?c.schoolCode:null,customerName:c?c.customerName:null,isLoading:g}),u(Fe,{onClick:()=>o(M=>!M),isOpen:e,hasNewMessage:!1}))}var yt,et=H(()=>{B();j();ze();Qe();Ge();Ze();yt=[{label:"Order Help",value:"I need help with an order"},{label:"Dress Code",value:"What's the dress code for my school?"},{label:"Sizing Help",value:"I need sizing help"}]});var bt=nt(()=>{B();Te();et();function tt(){let t=document.getElementById("scout-widget-host");if(!t)return;let e=t.attachShadow({mode:"open"}),o=document.createElement("style");o.textContent=Ee,e.appendChild(o);let s={};try{let n=document.getElementById("scout-page-context");n&&(s=JSON.parse(n.textContent))}catch{}let i=document.createElement("div");e.appendChild(i),Ie(u(pe,{pageContext:s}),i)}document.readyState==="loading"?document.addEventListener("DOMContentLoaded",tt):tt()});bt();})();
